<template>
  <div>
    <div class="flex-base">
      <div v-if="shouldShowPrevButtons">
        <md-button class="md-icon-button" @click="() => handleGoto(1)">
          <md-icon>keyboard_double_arrow_left</md-icon>
        </md-button>
      </div>

      <div v-if="shouldShowPrevButtons">
        <md-button
          class="md-icon-button"
          @click="() => handleGoto(currentPage - 1)"
        >
          <md-icon>chevron_left</md-icon>
        </md-button>
      </div>

      <div class="flex-base">
        <div v-for="(page, i) in showPages" :key="i">
          <md-button
            class="md-icon-button"
            :class="{ 'md-primary': page.current, 'md-raised': page.current }"
            @click="() => !page.current && handleGoto(page.page)"
          >
            {{ page.page }}
          </md-button>
        </div>
      </div>

      <div v-if="shouldShowNextButton">
        <md-button
          class="md-icon-button"
          @click="() => handleGoto(currentPage + 1)"
        >
          <md-icon>navigate_next</md-icon>
        </md-button>
      </div>

      <div v-if="shouldShowLastButton">
        <md-button class="md-icon-button" @click="() => handleGoto(totalPages)">
          <md-icon>keyboard_double_arrow_right</md-icon>
        </md-button>
      </div>
    </div>
    <div
      v-if="shouldShowPages && pageCount && totalCount"
      class="flex-base mt-1"
    >
      <span class="md-caption">
        {{ (currentPage - 1) * pageSize + 1 }} -
        {{ maxCountOfItensInThePage }} de {{ totalCount }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlowPagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    pagesToShow: {
      type: Number,
      default: 2,
    },
    shouldShowPages: {
      type: Boolean,
      default: true,
    },
    totalCount: {
      type: Number,
      default: 0,
      required: false,
    },
    totalPages: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  computed: {
    maxCountOfItensInThePage() {
      const total = this.currentPage * this.pageSize

      if (total > this.totalCount) return this.totalCount

      return total
    },
    shouldShowPrevButtons() {
      return this.currentPage > 1
    },
    shouldShowNextButton() {
      if (this.totalPages) return this.currentPage < this.totalPages
      return this.pageCount === this.pageSize
    },
    shouldShowLastButton() {
      return this.totalPages && this.currentPage < this.totalPages
    },
    showPages() {
      const current = {
        page: this.currentPage,
        current: true,
      }

      const next = this.getNextPages()
      const prev = this.getPrevPages()

      return [...prev, current, ...next]
    },
  },
  methods: {
    handleGoto(page) {
      this.$emit('change', page)
    },
    getNextPages() {
      const pages = []
      let i = this.currentPage
      while (
        ++i <= this.currentPage + this.pagesToShow &&
        i <= this.totalPages
      ) {
        pages.push({
          page: i,
          current: false,
        })
      }
      return pages
    },
    getPrevPages() {
      let pages = []
      let i = this.currentPage
      while (--i >= this.currentPage - this.pagesToShow && i > 0) {
        pages = [
          {
            page: i,
            current: false,
          },
          ...pages,
        ]
      }
      return pages
    },
  },
}
</script>

<style scoped lang="scss">
.flex-base {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
